// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__lmwP5","col":"styles_col__3dkXr"};